import { PlatformType } from '../types/models/bridge';

export function isTouchDevice() {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        ((window as any).DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof (window as any).DocumentTouch))
    ) || !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints)
  );
}

// Build-time platform detection via window.TAURI_PLATFORM (set by vite define from TAURI_ENV_TARGET_TRIPLE)
// Falls back to runtime detection for non-Tauri builds (web)
export const isIOS = () =>
  (window as any).TAURI_PLATFORM === 'ios' ||
  (!!navigator.platform && /ipad|iphone|ipod/i.test(navigator.platform));

export const isAndroid = () =>
  (window as any).TAURI_PLATFORM === 'android' ||
  /android/i.test(navigator.userAgent);

export const isChromebook = () =>
  /(chromebook| cros )/i.test(navigator.userAgent);

export const isWebApp = (platform: PlatformType) => {
  return ['web', 'lti', 'office'].includes(platform);
};

export const isNativeApp = (platform: PlatformType) => {
  return ['windows', 'osx', 'ios', 'android'].includes(platform);
};

export const isFirefox = () =>
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

/**
 * Detects if the app is running on a desktop platform (Windows, macOS, Linux).
 * This is used to determine which auth flow to use:
 * - Desktop: opener + deep-link (opens system browser, callback via deep link)
 * - Mobile (iOS/Android): web-auth plugin (in-app browser that auto-dismisses)
 */
export const isDesktopPlatform = () => {
  // Check for mobile platforms first
  if (isIOS() || isAndroid()) {
    return false;
  }
  // If we're in Tauri but not iOS/Android, we're on desktop
  const isTauri = (window as any).__TAURI__ !== undefined;
  if (isTauri) {
    return true;
  }
  return false;
};

export const isSafari = () =>
  navigator.vendor &&
  navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;

export const isEdge = () =>
  navigator.userAgent.toLowerCase().indexOf('edge') > -1 ||
  navigator.userAgent.toLowerCase().indexOf('edg') > -1;
